/* eslint-disable array-callback-return */
import React from 'react';
import { default as BoxWrapper } from '@mui/material/Box';
export var Box = function Box(_ref) {
  var sx = _ref.sx,
    _ref$component = _ref.component,
    component = _ref$component === void 0 ? 'div' : _ref$component,
    children = _ref.children,
    testId = _ref.testId,
    id = _ref.id,
    onClick = _ref.onClick,
    className = _ref.className;
  return /*#__PURE__*/React.createElement(BoxWrapper, {
    component: component,
    sx: sx,
    id: id,
    "data-testid": testId,
    onClick: onClick,
    className: "__ds__comp ".concat(className)
  }, children);
};